import { forwardRef, type Ref, type SVGProps } from "react";

function SvgVerifiedColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" {...props}>
      <path
        fill="#1240A1"
        fillRule="evenodd"
        d="M6.814 1.596a1.677 1.677 0 0 1 2.372 0l.72.72c.19.19.446.296.714.296h1.196c.926 0 1.677.75 1.677 1.677v1.195c0 .268.106.525.296.715l.72.72a1.677 1.677 0 0 1 0 2.371l-.72.72a1 1 0 0 0-.296.715v1.195c0 .926-.751 1.677-1.677 1.677H10.62a1 1 0 0 0-.714.296l-.72.72a1.677 1.677 0 0 1-2.372 0l-.72-.72a1 1 0 0 0-.714-.296H4.184c-.926 0-1.677-.75-1.677-1.677v-1.195a1 1 0 0 0-.296-.715l-.72-.72a1.677 1.677 0 0 1 0-2.371l.72-.72c.19-.19.296-.447.296-.715V4.289c0-.926.751-1.677 1.677-1.677H5.38c.268 0 .525-.107.714-.296z"
        clipRule="evenodd"
      />
      <path
        fill="#B7DDFF"
        fillRule="evenodd"
        stroke="#B7DDFF"
        strokeWidth={0.5}
        d="M10.442 6.293a.333.333 0 1 0-.55-.377l-2.756 4.02-1.414-1.264a.333.333 0 0 0-.444.498l1.697 1.516a.333.333 0 0 0 .497-.06z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgVerifiedColored);
export default ForwardRef;
